import React from 'react';
import { Typography } from "@mui/material";

const EmptyField = () => {
  return <Typography variant="body2" sx={{ fontStyle: 'italic' }}>n/a</Typography>
};

export default EmptyField;
